import { FC } from 'react';
import {
  checkLockOnPage,
  ObjectType,
  Spinner,
  useIsAdmin,
  useObjectLockQuery,
  useSystemClassifierQuery,
} from '@atlas-frontend/sdk';
import { path } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';
import { useNumericParam } from '../../common/useEntityIdParam';
import { Forbidden } from '../Forbidden';
import { NotFound } from '../NotFound';
import { SystemClassifierForm } from './SystemClassifierForm';

export const SystemClassifierEdit = () => {
  const systemClassifierId = useNumericParam('id');

  if (!useIsAdmin()) {
    return <Forbidden />;
  }

  if (!systemClassifierId) {
    return <NotFound />;
  }

  return <SystemClassifierEditInner systemClassifierId={systemClassifierId} />;
};

const SystemClassifierEditInner: FC<{ systemClassifierId: number }> = (
  props
) => {
  const { systemClassifierId } = props;
  const {
    data: systemClassifier,
    isLoading,
    refetch,
  } = useSystemClassifierQuery({
    id: systemClassifierId,
  });
  const { data: lockData } = useObjectLockQuery({
    objectId: systemClassifierId,
    objectType: ObjectType.SystemClassifier,
  });
  const navigateToSystemClassifierView = useNavigateTo(
    path.systemClassifierDetails,
    { id: systemClassifierId }
  );
  checkLockOnPage(lockData, () => navigateToSystemClassifierView);

  if (isLoading) {
    return <Spinner />;
  }

  if (!systemClassifier) {
    return null;
  }

  return (
    <SystemClassifierForm
      id={systemClassifierId}
      defaultValues={systemClassifier}
      onClickCancel={() => navigateToSystemClassifierView()}
      onSuccess={() => {
        void refetch();
      }}
    />
  );
};
